const { registerBlockType } = wp.blocks;
const {
  RichText,
  URLInputButton,
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
} = wp.blockEditor;
const { Button, Icon, PanelBody, SelectControl } = wp.components;
const { Fragment } = wp.element;
const { __ } = wp.i18n;

registerBlockType('pg/product-nav-section', {
  title: 'PG Product Tiles',
  icon: 'screenoptions',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    items: {
      type: 'array',
      default: [],
    },
    sectionClass: {
      type: 'string',
      default: 'section-light-primary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-disabled',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-primary',
    },
    gridClass: {
      type: 'string',
      default: 'product-nav-list product-nav-list-cols-3',
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const {
      items,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      gridClass,
    } = attributes;

    const addItem = (type) => {
      const newItem = {
        type,
        title: 'Sustainability suite',
        imgUrl:
          type === 'big'
            ? '/wp-content/themes/positiongreen/resources/images/placeholders/photo_placeholder.png'
            : '',
        link: '#',
      };
      setAttributes({ items: [...items, newItem] });
    };

    const updateItem = (index, updates) => {
      const newItems = items.map((item, i) =>
        i === index ? { ...item, ...updates } : item
      );
      setAttributes({ items: newItems });
    };

    const removeItem = (index) => {
      const newItems = items.filter((_, i) => i !== index);
      setAttributes({ items: newItems });
    };

    const getItemContent = (item, index) => {
      return (
        <div
          className={`product-nav-list-item ${item.type === 'small' ? 'product-nav-list-item-small' : ''}`}
          key={index}
        >
          {item.type === 'big' && item.imgUrl && (
            <img src={item.imgUrl} alt={item.altText} />
          )}
          <URLInputButton
            className={'rightContentButton'}
            url={item.link}
            onChange={(link) => updateItem(index, { link })}
          />
          <div className="product-nav-list-item-content">
            <RichText
              tagName="strong"
              value={item.title}
              onChange={(title) => updateItem(index, { title })}
              placeholder={__('Enter title...')}
            />
            <a href={item.link} className="btn btn-solid btn-dark btn-icon"></a>
          </div>

          {item.type === 'big' && (
            <MediaUploadCheck>
              <MediaUpload
                onSelect={(media) =>
                  updateItem(index, {
                    imgUrl: media.url,
                    altText: media.alt || '',
                  })
                }
                allowedTypes={['image']}
                value={item.imgUrl}
                render={({ open }) => (
                  <Button
                    onClick={open}
                    isPrimary
                    className={'orientationButton'}
                  >
                    {__('Change Image')}
                  </Button>
                )}
              />
            </MediaUploadCheck>
          )}
          <Button
            isSmall
            onClick={() => removeItem(index)}
            className={'removeButton'}
          >
            {__('Remove Item')}
          </Button>
        </div>
      );
    };

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    const onChangeCornerPositionClass = (newClass) => {
      setAttributes({ cornerPositionClass: newClass });
    };

    const onChangeCornerBackgroundClass = (newClass) => {
      setAttributes({ cornerBackgroundClass: newClass });
    };

    const onChangeGridClass = (newClass) => {
      setAttributes({ gridClass: newClass });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Section Settings')}>
            <Button isSecondary onClick={() => addItem('big')}>
              + Add Big Item
            </Button>
            <Button isSecondary onClick={() => addItem('small')}>
              + Add Small Item
            </Button>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
            <SelectControl
              label={__('Corner Position')}
              value={cornerPositionClass}
              options={[
                { label: 'None', value: 'corner-disabled' },
                { label: 'Left-Top', value: 'corner-left-top' },
                { label: 'Left-Bottom', value: 'corner-left-bottom' },
                { label: 'Right-Top', value: 'corner-right-top' },
                { label: 'Right-Bottom', value: 'corner-right-bottom' },
              ]}
              onChange={onChangeCornerPositionClass}
            />
            <SelectControl
              label={__('Corner Background')}
              value={cornerBackgroundClass}
              options={[
                { label: 'Dark Primary', value: 'corner-on-dark-primary' },
                { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
                { label: 'Light Primary', value: 'corner-on-light-primary' },
                {
                  label: 'Light Secondary',
                  value: 'corner-on-light-secondary',
                },
              ]}
              onChange={onChangeCornerBackgroundClass}
            />
            <SelectControl
              label={__('Grid Columns')}
              value={gridClass}
              options={[
                {
                  label: '3 Columns',
                  value: 'product-nav-list product-nav-list-cols-3',
                },
                { label: '2 Columns', value: 'product-nav-list' },
              ]}
              onChange={onChangeGridClass}
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass}>
          <div
            className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
          ></div>
          <div className="product-nav-section-wrapper">
            <div className={gridClass}>
              {items.map((item, index) => getItemContent(item, index))}
            </div>
          </div>
        </section>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const {
      items,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      gridClass,
    } = attributes;

    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace('section', 'corner')} ${cornerBackgroundClass}`}
        ></div>
        <div className="product-nav-section-wrapper">
          <div className={gridClass}>
            {items.map((item, index) => (
              <div
                className={`product-nav-list-item ${item.type === 'small' ? 'product-nav-list-item-small' : ''}`}
                key={index}
              >
                {item.type === 'big' && item.imgUrl && (
                  <img src={item.imgUrl} alt={item.altText} />
                )}
                <div className="product-nav-list-item-content">
                  <RichText.Content tagName="strong" value={item.title} />
                  <a
                    href={item.link}
                    className="btn btn-solid btn-dark btn-icon"
                  ></a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  },
});
